import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录',
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'Register', 
    component: () => import('@/views/Register.vue'),
    meta: {
      title: '注册',
      requiresAuth: false
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          title: '仪表盘',
          icon: 'el-icon-s-home'
        }
      },
      // 考试管理
      {
        path: 'exam/list',
        name: 'ExamList',
        component: () => import('@/views/exam/ExamList.vue'),
        meta: {
          title: '考试列表',
          icon: 'el-icon-folder-opened'
        }
      },
      {
        path: 'exam/create',
        name: 'ExamCreate',
        component: () => import('@/views/exam/ExamCreate.vue'),
        meta: {
          title: '创建考试',
          icon: 'el-icon-plus'
        }
      },
      {
        path: 'exam/edit/:id',
        name: 'ExamEdit',
        component: () => import('@/views/exam/ExamEdit.vue'),
        meta: {
          title: '编辑考试',
          icon: 'el-icon-edit'
        }
      },
      {
        path: 'exam/detail/:id',
        name: 'ExamDetail',
        component: () => import('@/views/exam/ExamDetail.vue'),
        meta: {
          title: '考试详情',
          icon: 'el-icon-view'
        }
      },
      
      // 题库管理
      {
        path: 'question/banks',
        name: 'QuestionBanks',
        component: () => import('@/views/question/QuestionBanks.vue'),
        meta: {
          title: '题库管理',
          icon: 'el-icon-folder'
        }
      },
      {
        path: 'question/list',
        name: 'QuestionList',
        component: () => import('@/views/question/QuestionList.vue'),
        meta: {
          title: '题目管理',
          icon: 'el-icon-document'
        }
      },
      {
        path: 'question/create-bank',
        name: 'QuestionCreateBank',
        component: () => import('@/views/question/QuestionCreateBank.vue'),
        meta: {
          title: '新建题库',
          icon: 'el-icon-plus'
        }
      },
      {
        path: 'question/manage',
        name: 'QuestionManage',
        component: () => import('@/views/question/QuestionManage.vue'),
        meta: {
          title: '题目管理',
          icon: 'el-icon-edit'
        }
      },
      {
        path: 'question/bank/:id',
        name: 'QuestionBankDetail',
        component: () => import('@/views/question/QuestionBankDetail.vue'),
        meta: {
          title: '题库详情',
          icon: 'el-icon-view'
        }
      },
      
      // 试卷管理
      {
        path: 'paper/list',
        name: 'PaperList',
        component: () => import('@/views/paper/PaperList.vue'),
        meta: {
          title: '试卷列表',
          icon: 'el-icon-tickets'
        }
      },
      {
        path: 'paper/create',
        name: 'PaperCreate',
        component: () => import('@/views/paper/PaperCreate.vue'),
        meta: {
          title: '创建试卷',
          icon: 'el-icon-circle-plus'
        }
      },
      {
        path: 'paper/create-simple',
        name: 'PaperCreateSimple',
        component: () => import('@/views/paper/PaperCreateSimple.vue'),
        meta: {
          title: '简化创建试卷',
          icon: 'el-icon-document-add'
        }
      },
      {
        path: 'paper/create-simple/:id',
        name: 'PaperEditSimple',
        component: () => import('@/views/paper/PaperCreateSimple.vue'),
        meta: {
          title: '编辑试卷',
          icon: 'el-icon-edit'
        }
      },
      {
        path: 'paper/builder',
        name: 'PaperBuilder',
        component: () => import('@/views/paper/PaperBuilder.vue'),
        meta: {
          title: '智能组卷',
          icon: 'el-icon-magic-stick'
        }
      },
      {
        path: 'paper/import',
        name: 'PaperImport',
        component: () => import('@/views/paper/PaperImport.vue'),
        meta: {
          title: '导入试卷',
          icon: 'el-icon-upload2'
        }
      },
      {
        path: 'paper/edit/:id',
        name: 'PaperEdit',
        component: () => import('@/views/paper/PaperCreate.vue'),
        meta: {
          title: '编辑试卷',
          icon: 'el-icon-edit'
        }
      },
      {
        path: 'paper/preview/:id',
        name: 'PaperPreview',
        component: () => import('@/views/paper/PaperPreview.vue'),
        meta: {
          title: '预览试卷',
          icon: 'el-icon-view'
        }
      },
      
      // 系统管理
      {
        path: 'system/subjects',
        name: 'SubjectManagement',
        component: () => import('@/views/system/SubjectManagement.vue'),
        meta: {
          title: '科目管理',
          icon: 'el-icon-notebook-1'
        }
      },
      {
        path: 'system/theme',
        name: 'SystemTheme',
        component: () => import('@/views/config/ThemeConfig.vue'),
        meta: {
          title: '主题设置',
          icon: 'el-icon-brush'
        }
      },
      {
        path: 'system/organizer',
        name: 'SystemOrganizer',
        component: () => import('@/views/system/OrganizerInfo.vue'),
        meta: {
          title: '机构信息',
          icon: 'el-icon-office-building'
        }
      },
      {
        path: 'system/accounts',
        name: 'SystemAccounts',
        component: () => import('@/views/system/SystemAccounts.vue'),
        meta: {
          title: '账号管理',
          icon: 'el-icon-user'
        }
      },
      {
        path: 'system/login-settings',
        name: 'LoginSettings',
        component: () => import('@/views/system/LoginSettings.vue'),
        meta: {
          title: '登录设置',
          icon: 'el-icon-key'
        }
      },
      
      // 个人资料
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
          title: '个人资料',
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面不存在'
    }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

// 解决重复导航错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err);
    }
  });
};

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 在线考试系统管理端` : '在线考试系统管理端';

  // 如果是登录页面或注册页面，直接通过
  if (to.path === '/login' || to.path === '/register') {
    next();
    return;
  }

  // 检查是否需要认证
  if (to.meta.requiresAuth !== false) {
    const token = store.getters['user/token'];
    
    if (!token) {
      // 避免重定向循环
      if (from.path !== '/login') {
        next('/login');
      } else {
        next();
      }
      return;
    }

    // 有token，检查用户信息是否存在
    const userInfo = store.getters['user/userInfo'];
    if (!userInfo || !userInfo.id) {
      // 有token但没有用户信息，尝试获取用户信息
      try {
        await store.dispatch('user/checkLogin');
        next();
      } catch (error) {
        console.error('Token验证失败:', error);
        
        // 检查是否是401错误或认证相关错误
        const isAuthError = error.message.includes('401') || 
                           error.message.includes('未授权') || 
                           error.message.includes('请先登录') ||
                           error.message.includes('登录已过期') ||
                           error.message.includes('用户信息获取失败');
        
        if (isAuthError) {
          // 清除用户数据
          await store.dispatch('user/logout');
          // 跳转到登录页
          if (to.path !== '/login' && from.path !== '/login') {
            next('/login');
          } else {
            next();
          }
        } else {
          // 其他错误，也跳转到登录页面
          await store.dispatch('user/logout');
          next('/login');
        }
      }
    } else {
      // 有token且有用户信息，直接通过
      next();
    }
  } else {
    next();
  }
});

export default router;